import { writable } from 'svelte/store'
import { browser } from '$app/environment'

let storedCart: CartItem[] = []
if (browser && localStorage.cartItems) {
	storedCart = JSON.parse(localStorage.cartItems) // initial load from localStorage
}
export const cartItems = writable<CartItem[]>(storedCart)
if (browser) cartItems.subscribe(value => (localStorage.cartItems = JSON.stringify(value))) // keep localStorage updated
